import styled from 'styled-components';
import { IStickyStyledProps } from './sticky.types';

export const StickyStyled = styled.div<IStickyStyledProps>`
  position: sticky;
  top: ${({ $top }) => $top};
  z-index: 2;
`;
